import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { OnlineCourseApi } from "../../../../api/cms-online-course/online_course.api";
import { useParams } from "react-router-dom";

export default function FileDiploma() {
  const { id } = useParams();
  const [value, setValue] = useState();
  const [file, setFile] = useState();
  const [filePath, setFilePath] = useState();
  useEffect(() => {
    // getdata()
    const style = document.createElement("style");
    style.innerHTML = `
        @page {
            margin: 0;
            size: 29.7cm 21cm;
            
          }
            `;
    document.head.appendChild(style);
    // getMasterGroup()
  }, []);
  const getData = async () => {
    await OnlineCourseApi.getDiploma(id)
      .then((res) => {
        if (res.status < 300) {
          setValue(res.data.data);
          setFilePath(
            process.env.REACT_APP_FILE_BASE_API +
              "/" +
              res.data.data.file_path +
              res.data.data.file_name
          );
        }
      })
      .catch((error) => {
        console.log(error);
        // swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
      });
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, []);
  return (
    <page>
      <div
        style={{
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundImage: `url(${filePath})`,
          width:'29.7cm',
          height:"21cm",
          display:'flex',
          alignItems:"center",
          justifyContent:'center'
        }}
      >
        <div>
            {value?.online_course_diploma_desc &&
          parse(value?.online_course_diploma_desc)}
        </div>
        
      </div>
    </page>
  );
}
